export default __webpack_public_path__ + "static/media/18.6a6d4cb0.png";